import React, { useState, useEffect } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import "./styles.css";
import { SafetyCertificateOutlined, UploadOutlined, EditOutlined, DeleteOutlined, QrcodeOutlined } from "@ant-design/icons";

import {
  Form,
  Input,
  Button,
  Select,
  Upload,
  notification,
  DatePicker,
  Spin,
  QRCode,
  Modal,
} from "antd";
import { db, storage } from "../../../services/firebase";
import {
  collection,
  getDocs,
  addDoc,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import Container from "../../../components/Container";
import { registrarAtividade } from "../../../services/atividadeService";

import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytesResumable,
} from "firebase/storage";

import dayjs from "dayjs";

const { Item, useForm } = Form;

// Remove undefined e converte datas para string no formato DD/MM/YYYY
function prepareValues(values) {
  const cleaned = Object.fromEntries(
    Object.entries(values).filter(([, v]) => v !== undefined)
  );

  if (cleaned.dataCalibracao) {
    if (cleaned.dataCalibracao.format) {
      cleaned.dataCalibracao = cleaned.dataCalibracao.format("DD/MM/YYYY");
    } else {
      cleaned.dataCalibracao = String(cleaned.dataCalibracao);
    }
  }

  if (cleaned.proximaCalibracao) {
    if (cleaned.proximaCalibracao.format) {
      cleaned.proximaCalibracao =
        cleaned.proximaCalibracao.format("DD/MM/YYYY");
    } else {
      cleaned.proximaCalibracao = String(cleaned.proximaCalibracao);
    }
  }

  return cleaned;
}

function CertificateForm() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [form] = useForm();

  const [fileListDatabook, setFileListDatabook] = useState([]);
  const [fileListCertificado, setFileListCertificado] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [valvulas, setValvulas] = useState([]);
  const [valvulasOptions, setValvulasOptions] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [valvulaSelecionada, setValvulaSelecionada] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fullscreenLoading, setFullscreenLoading] = useState(false);
  const [filesCertificados, setFilesCertificados] = useState([]);
  const [filesDatabook, setFilesDatabook] = useState([]);
  const [url, setUrl] = useState(null);
  const [preSelectedValveId, setPreSelectedValveId] = useState(null);
  const [qrModalVisible, setQrModalVisible] = useState(false);

  const handleChangeUploadDatabook = ({ fileList: newFileList }) =>
    setFileListDatabook(newFileList);

  const handleChangeUploadCertificado = ({ fileList: newFileList }) =>
    setFileListCertificado(newFileList);

  const handleDelete = () => {
    const tag = form.getFieldValue("tag") || "este certificado";
    Modal.confirm({
      title: "Deseja excluir este certificado?",
      content: `O certificado da válvula "${tag}" será removido permanentemente.`,
      okText: "Sim, excluir",
      okType: "danger",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          await deleteDoc(doc(db, "certificados", id));

          // Registrar atividade
          const usuario = JSON.parse(sessionStorage.getItem("seepilUsuario"));
          await registrarAtividade(
            "Certificado excluído",
            tag,
            usuario?.nomeUsuario
          );

          notification.success({
            message: "Certificado excluído!",
            description: "O certificado foi removido com sucesso.",
            placement: "topRight",
          });
          navigate("/admin/certificados");
        } catch (error) {
          console.error("Erro ao excluir certificado:", error);
          notification.error({
            message: "Erro ao excluir",
            description: "Não foi possível excluir o certificado.",
            placement: "topRight",
          });
        }
      },
    });
  };

  const getUnidades = (idCliente) => {
    const resultado = clientes.find((cliente) => cliente.id === idCliente);
    setUnidades(resultado ? resultado.unidades : []);
    form.setFieldValue("unidadeCliente", undefined);
    form.setFieldValue("valvula_id", undefined);
    setValvulaSelecionada(null);
  };

  const getValvula = (idValvula) => {
    const resultado = valvulas.find((valvula) => valvula.id === idValvula);
    if (!resultado) return;

    form.setFieldValue("tag", resultado.tag);
    form.setFieldValue("fabricante", resultado.fabricante);
    form.setFieldValue("modelo", resultado.modelo);
    form.setFieldValue("numeroSerie", resultado.numeroSerie);
    form.setFieldValue("tipoValvula", resultado.tipoValvula);
  };

  // Busca clientes
  const fetchClientesFirebase = async () => {
    try {
      const snapshot = await getDocs(collection(db, "clientes"));
      const data = snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }));

      setClientes(data);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    }
  };

  const getValvulas = (unidade) => {
    const clienteId = form.getFieldValue("cliente_id");
    const result = valvulas.filter(
      (valvula) =>
        valvula.cliente_id === clienteId && valvula.unidadeCliente === unidade
    );
    setValvulasOptions(result);
    setValvulaSelecionada(unidade);
  };

  const fetchFromCollection = async (collectionName) => {
    const snapshot = await getDocs(collection(db, collectionName));
    return snapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));
  };

  // Busca válvulas
  const fetchValvulasFirebase = async () => {
    try {
      const [valvulasBloqueio, valvulasPSV, valvulasControle] =
        await Promise.all([
          fetchFromCollection("valvulasBloqueio"),
          fetchFromCollection("valvulasPSV"),
          fetchFromCollection("valvulasControle"),
        ]);
      const data = [...valvulasBloqueio, ...valvulasControle, ...valvulasPSV];

      setValvulas(data);
    } catch (error) {
      console.error("Erro ao listar válvulas:", error);
    }
  };

  // Busca certificado para edição
  const fetchCertificate = async () => {
    const refDoc = doc(db, "certificados", id);
    const snapshot = await getDoc(refDoc);
    const data = snapshot.data();
    if (!data) return;

    if (data.dataCalibracao) {
      if (typeof data.dataCalibracao === "string") {
        data.dataCalibracao = dayjs(data.dataCalibracao, "DD/MM/YYYY");
      } else if (data.dataCalibracao.toDate) {
        data.dataCalibracao = dayjs(data.dataCalibracao.toDate());
      }
    }

    if (data.proximaCalibracao) {
      if (typeof data.proximaCalibracao === "string") {
        data.proximaCalibracao = dayjs(
          data.proximaCalibracao,
          "DD/MM/YYYY"
        );
      } else if (data.proximaCalibracao.toDate) {
        data.proximaCalibracao = dayjs(data.proximaCalibracao.toDate());
      }
    }

    form.setFieldsValue(data);
  };

  useEffect(() => {
    fetchClientesFirebase();
    fetchValvulasFirebase();
  }, []);

  useEffect(() => {
    form.setFieldsValue({});
    if (id) {
      fetchCertificate();
      getFiles();
    }
  }, [id]);

  // Pré-preenche o formulário quando vem de cadastro de válvula
  useEffect(() => {
    const valvulaIdFromUrl = searchParams.get("valvula_id");
    if (valvulaIdFromUrl && valvulas.length > 0 && clientes.length > 0) {
      const valvula = valvulas.find((v) => v.id === valvulaIdFromUrl);
      if (valvula) {
        // Pré-seleciona o cliente
        form.setFieldValue("cliente_id", valvula.cliente_id);

        // Carrega as unidades do cliente
        const cliente = clientes.find((c) => c.id === valvula.cliente_id);
        if (cliente) {
          setUnidades(cliente.unidades || []);

          // Pré-seleciona a unidade
          form.setFieldValue("unidadeCliente", valvula.unidadeCliente);

          // Filtra válvulas da unidade selecionada
          const valvulasFiltradas = valvulas.filter(
            (v) =>
              v.cliente_id === valvula.cliente_id &&
              v.unidadeCliente === valvula.unidadeCliente
          );
          setValvulasOptions(valvulasFiltradas);

          // Pré-seleciona a válvula
          form.setFieldValue("valvula_id", valvulaIdFromUrl);

          // Preenche os campos da válvula
          form.setFieldValue("tag", valvula.tag);
          form.setFieldValue("fabricante", valvula.fabricante);
          form.setFieldValue("modelo", valvula.modelo);
          form.setFieldValue("numeroSerie", valvula.numeroSerie);
          form.setFieldValue("tipoValvula", valvula.tipoValvula);
          form.setFieldValue("spl", valvula.id);

          notification.success({
            message: "Válvula pré-selecionada!",
            description: `Os dados da válvula ${valvula.tag} foram carregados automaticamente.`,
            placement: "topRight",
            duration: 4,
          });
        }
      }
    }
  }, [valvulas, clientes, searchParams]);

  async function uploadFile(idDoc) {
    if (fileListCertificado.length > 0) {
      await Promise.all(
        fileListCertificado.map((file) =>
          uploadBytesResumable(
            ref(storage, `${idDoc}/certificados/${file.originFileObj.name}`),
            file.originFileObj
          )
        )
      );
    }
    if (fileListDatabook.length > 0) {
      await Promise.all(
        fileListDatabook.map((file) =>
          uploadBytesResumable(
            ref(storage, `${idDoc}/databook/${file.originFileObj.name}`),
            file.originFileObj
          )
        )
      );
    }
  }

  function handleCriarQrCode() {
    const link = `https://seepil.web.app/certificado/${id}`;
    setUrl(link);
    setQrModalVisible(true);
  }

  function doDownload(link, fileName) {
    const a = document.createElement("a");
    a.download = fileName;
    a.href = link;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  
  function downloadQrCode() {
    const canvas = document.querySelector(".ant-modal canvas");
    if (canvas) {
      const urlCanvas = canvas.toDataURL();
      const tag = form.getFieldValue("tag") || "certificado";
      const numeroCert = form.getFieldValue("numeroCertificado") || "";
      const fileName = `QRCode_${tag}${numeroCert ? "_" + numeroCert : ""}.png`;
      doDownload(urlCanvas, fileName);
    }
  }

  const handleSubmit = async (values) => {
    try {
      setFullscreenLoading(true);

      const valoresProntos = prepareValues(values);

      const response = await addDoc(
        collection(db, "certificados"),
        valoresProntos
      );
      await uploadFile(response.id);

      // Registrar atividade
      const usuario = JSON.parse(sessionStorage.getItem("seepilUsuario"));
      const tag = valoresProntos.tag || "";
      const cliente = clientes.find((c) => c.id === valoresProntos.cliente_id);
      const nomeCliente = cliente?.nomeEmpresa || "";
      await registrarAtividade(
        "Novo certificado emitido",
        `${tag} • ${nomeCliente}`,
        usuario?.nomeUsuario
      );

      form.resetFields();
      setFileListCertificado([]);
      setFileListDatabook([]);
      setValvulaSelecionada(null);

      notification.success({
        message: "Certificado cadastrado!",
        description:
          "O certificado foi inserido com sucesso no banco de dados.",
        placement: "topRight",
      });

      // Redireciona para a lista de certificados
      navigate("/admin/certificados");
    } catch (error) {
      console.error("Erro ao cadastrar certificado:", error);

      notification.error({
        message: "Erro ao cadastrar certificado",
        description: "O certificado não foi cadastrado. Tente novamente.",
        placement: "topRight",
      });
    } finally {
      setFullscreenLoading(false);
    }
  };

  const handleSave = async (values) => {
    try {
      setFullscreenLoading(true);

      const valoresProntos = prepareValues(values);

      const refDoc = doc(db, "certificados", id);
      await updateDoc(refDoc, valoresProntos);
      await uploadFile(id);

      // Registrar atividade
      const usuario = JSON.parse(sessionStorage.getItem("seepilUsuario"));
      const tag = form.getFieldValue("tag") || "";
      const clienteId = form.getFieldValue("cliente_id");
      const cliente = clientes.find((c) => c.id === clienteId);
      const nomeCliente = cliente?.nomeEmpresa || "";
      await registrarAtividade(
        "Certificado atualizado",
        `${tag} • ${nomeCliente}`,
        usuario?.nomeUsuario
      );

      notification.success({
        message: "Certificado atualizado!",
        description:
          "O certificado foi atualizado com sucesso no banco de dados.",
        placement: "topRight",
      });

      setIsEditing(false);
    } catch (error) {
      console.error("Erro ao atualizar certificado:", error);

      notification.error({
        message: "A atualização falhou.",
        description: "O certificado não foi atualizado. Tente novamente.",
        placement: "topRight",
      });
    } finally {
      setFullscreenLoading(false);
    }
  };

  const FullscreenSpinner = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin size="large" tip="Processando..." />
    </div>
  );

  async function getFiles() {
    const listCertificadosRef = ref(storage, `${id}/certificados`);
    const listDatabookRef = ref(storage, `${id}/databook`);

    const [resultadoCertificados, resultadoDatabook] = await Promise.all([
      listAll(listCertificadosRef),
      listAll(listDatabookRef),
    ]);

    const nomesCertificados = resultadoCertificados.items.map(
      (item) => item.fullPath.split("certificados/")[1]
    );

    const pdfCertificados = await Promise.all(
      resultadoCertificados.items.map((pdf) => getDownloadURL(pdf))
    );

    const pdfDatabook = await Promise.all(
      resultadoDatabook.items.map((pdf) => getDownloadURL(pdf))
    );

    const nomesDatabooks = resultadoDatabook.items.map(
      (item) => item.fullPath.split("databook/")[1]
    );

    const certificados = pdfCertificados.map((link, index) => ({
      nome: nomesCertificados[index],
      link,
    }));

    const databook = pdfDatabook.map((link, index) => ({
      nome: nomesDatabooks[index],
      link,
    }));

    setFilesCertificados(certificados);
    setFilesDatabook(databook);
  }

  return (
    <Container>
      <Spin spinning={loading} tip="Processando..." size="large">
        <div style={{ minHeight: "400px" }}>
          <div className="certificate-form-content">
            <div className="certificate-form-container">
              <div className="form-header">
                <div className="form-header-left">
                  <div className="form-icon">
                    <SafetyCertificateOutlined />
                  </div>
                  <div>
                    <h2 className="form-title">{id ? "Editar Certificado" : "Cadastrar Certificado"}</h2>
                  </div>
                </div>
              </div>

              <Form
                onFinish={id ? handleSave : handleSubmit}
                layout="vertical"
                form={form}
                className="custom-form"
              >
                <p className="form-section-title">Seleção</p>
                <div className="form-row">
                  <Item label="Cliente" name="cliente_id">
                    <Select
                      disabled={id && !isEditing}
                      allowClear
                      onChange={getUnidades}
                      placeholder="Selecione um cliente"
                      required
                    >
                      {clientes.map((cliente) => (
                        <option key={cliente.id} value={cliente.id}>
                          {cliente.nomeEmpresa}
                        </option>
                      ))}
                    </Select>
                  </Item>

                  <Item label="Unidade" name="unidadeCliente">
                    <Select
                      allowClear
                      onChange={getValvulas}
                      disabled={unidades.length === 0}
                      placeholder="Selecione uma unidade"
                      required
                    >
                      {unidades.map((unidade, index) => (
                        <option key={index} value={unidade.unidade}>
                          {unidade.unidade}
                        </option>
                      ))}
                    </Select>
                  </Item>

                  <Item label="Válvula" name="valvula_id">
                    <Select
                      allowClear
                      disabled={!valvulaSelecionada}
                      placeholder="Selecione uma válvula"
                      onChange={getValvula}
                      required
                    >
                      {valvulasOptions.map((valvula) => (
                        <option key={valvula.id} value={valvula.id}>
                          Tipo: {valvula.tipoValvula} / Tag: {valvula.tag} / Nº
                          Série: {valvula.numeroSerie}
                        </option>
                      ))}
                    </Select>
                  </Item>
                </div>

                <p className="form-section-title">Dados do Certificado</p>
                <div className="form-row">
                  <Item label="Tipo de Certificado" name="tipoCertificado">
                    <Select disabled={id && !isEditing} placeholder="Selecione o tipo">
                      <option value="onshore">ONSHORE</option>
                      <option value="offshore">OFFSHORE</option>
                      <option value="fornecimento">FORNECIMENTO</option>
                    </Select>
                  </Item>

                  <Item label="Nº Certificado" name="numeroCertificado">
                    <Input
                      placeholder="Ex: CERT-2024-001"
                      required
                      disabled={id && !isEditing}
                    />
                  </Item>

                  <Item label="Controle Interno SPL" name="spl">
                    <Input
                      placeholder="Ex: SPL-001"
                      required
                      disabled={id && !isEditing}
                    />
                  </Item>
                </div>

                <div className="form-row">
                  <Item label="Data de Calibração" name="dataCalibracao">
                    <DatePicker
                      disabled={id && !isEditing}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      placeholder="Selecione a data"
                    />
                  </Item>

                  <Item label="Próxima Calibração" name="proximaCalibracao">
                    <DatePicker
                      disabled={id && !isEditing}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      placeholder="Selecione a data"
                    />
                  </Item>

                  <Item label="Tag" name="tag">
                    <Input placeholder="Preenchido automaticamente" disabled required />
                  </Item>
                </div>

                <p className="form-section-title">Dados da Válvula</p>
                <div className="form-row">
                  <Item label="Fabricante" name="fabricante">
                    <Input placeholder="Preenchido automaticamente" disabled required />
                  </Item>

                  <Item label="Modelo" name="modelo">
                    <Input placeholder="Preenchido automaticamente" disabled required />
                  </Item>

                  <Item label="Número de Série" name="numeroSerie">
                    <Input placeholder="Preenchido automaticamente" disabled required />
                  </Item>
                </div>

                <div className="form-row">
                  <Item label="Tipo da Válvula" name="tipoValvula">
                    <Input placeholder="Preenchido automaticamente" disabled required />
                  </Item>
                </div>

                {/* Uploads */}
                <p className="form-section-title">Arquivos</p>
                <div className="form-row-2">
                  <div className="upload-box">
                    <label className="upload-box-label">Certificados</label>
                    <Upload
                      listType="picture"
                      fileList={fileListCertificado}
                      onChange={handleChangeUploadCertificado}
                      disabled={id && !isEditing}
                      beforeUpload={() => false}
                    >
                      <Button
                        disabled={id && !isEditing}
                        icon={<UploadOutlined />}
                        className="upload-btn"
                      >
                        Selecionar arquivos
                      </Button>
                    </Upload>
                    {filesCertificados.length > 0 && (
                      <div className="files-list">
                        {filesCertificados.map((item) => (
                          <a key={item.link} href={item.link} target="_blank" rel="noopener noreferrer">
                            {item.nome}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="upload-box">
                    <label className="upload-box-label">Databook</label>
                    <Upload
                      listType="picture"
                      fileList={fileListDatabook}
                      onChange={handleChangeUploadDatabook}
                      disabled={id && !isEditing}
                      beforeUpload={() => false}
                    >
                      <Button
                        disabled={id && !isEditing}
                        icon={<UploadOutlined />}
                        className="upload-btn"
                      >
                        Selecionar arquivos
                      </Button>
                    </Upload>
                    {filesDatabook.length > 0 && (
                      <div className="files-list">
                        {filesDatabook.map((item) => (
                          <a key={item.link} href={item.link} target="_blank" rel="noopener noreferrer">
                            {item.nome}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Botões */}
                <div className="form-actions">
                  {!id && (
                    <Button
                      htmlType="submit"
                      type="primary"
                      className="btn-primary"
                    >
                      Cadastrar Certificado
                    </Button>
                  )}

                  {id && !isEditing && (
                    <>
                      <Button
                        onClick={() => setIsEditing(true)}
                        type="primary"
                        className="btn-primary"
                        icon={<EditOutlined />}
                      >
                        Editar Certificado
                      </Button>
                      <Button
                        onClick={handleDelete}
                        className="btn-danger"
                        icon={<DeleteOutlined />}
                      >
                        Excluir Certificado
                      </Button>
                      <Button
                        onClick={handleCriarQrCode}
                        className="btn-secondary"
                        icon={<QrcodeOutlined />}
                      >
                        Gerar QR Code
                      </Button>
                    </>
                  )}

                  {id && isEditing && (
                    <>
                      <Button htmlType="submit" type="primary" className="btn-primary">
                        Salvar Alterações
                      </Button>
                      <Button onClick={() => setIsEditing(false)} className="btn-secondary">
                        Cancelar Edição
                      </Button>
                    </>
                  )}
                </div>
              </Form>

              {/* Modal QR Code */}
              <Modal
                title="QR Code do Certificado"
                open={qrModalVisible}
                onCancel={() => setQrModalVisible(false)}
                footer={[
                  <Button key="download" type="primary" onClick={downloadQrCode}>
                    Baixar QR Code
                  </Button>,
                  <Button key="close" onClick={() => setQrModalVisible(false)}>
                    Fechar
                  </Button>,
                ]}
                centered
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                  {url && <QRCode value={url} size={256} type="canvas" />}
                  <p style={{ color: "#666", fontSize: "12px", textAlign: "center", wordBreak: "break-all" }}>
                    {url}
                  </p>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </Spin>
      {fullscreenLoading && <FullscreenSpinner />}
    </Container>
  );
}

export default CertificateForm;
